import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "draivn-onboarding-page-wrapper full-width drv-bg-color-n0" }

import { storeToRefs } from "pinia";
import { onBeforeMount, ref } from "vue";
import { ROUTER_SERVICE_INJECTION_KEY } from "@/constants";
import { ROUTE_HOME_NAME } from "@/modules/app";
import { injector } from "@/services";
import {
  ROUTE_COMPLETED_INVITE_NAME,
  ROUTE_CONGRATS_NAME,
  ROUTE_ONBOARDING_NAME,
  ROUTE_WELCOME_NAME,
} from "../constants";
import { useOnboardingStore } from "../services";
import "../assets/css/main.scss";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainComponent',
  setup(__props) {

const $onboardingStore = useOnboardingStore();
const { isCompletedInvite, sessionId, token } = storeToRefs($onboardingStore);

const router = injector.injectFromRoot(ROUTER_SERVICE_INJECTION_KEY);

const isLoading = ref(false);
const isInited = ref(false);

const init = async () => {
  if (isCompletedInvite.value) {
    router.replace({ name: ROUTE_COMPLETED_INVITE_NAME });
  } else if (sessionId.value) {
    const responses = await Promise.all([
      $onboardingStore.getModel(),
      $onboardingStore.setNaicsCodes(),
    ]);
    const model = responses[0];
    if (model) {
      if (model.approve) {
        router.replace({ name: ROUTE_CONGRATS_NAME });
      } else if (token.value) {
        router.replace({ name: ROUTE_ONBOARDING_NAME });
      } else {
        router.replace({ name: ROUTE_WELCOME_NAME });
      }
    } else {
      throw new Error("Model not found");
    }
  } else {
    router.replace({ name: ROUTE_HOME_NAME });
  }
  isInited.value = true;
};

onBeforeMount(async () => {
  isLoading.value = true;
  await init();
  isLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isInited.value)
      ? (_openBlock(), _createBlock(_component_router_view, {
          key: 0,
          class: "draivn-onboarding-page"
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})